import { Paper, Backdrop, CircularProgress, Box, TextField, Container, Grid, Card, CardContent, Typography, CardActions, Button, Divider, Stack, Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from "@suid/material"
import { createResource, createSignal, For, Show, useContext } from "solid-js";
import { Book, Delete, Edit } from "@suid/icons-material";
import { deleteRunbook, getRunbook, getRunbooks, upsertBook } from "../runbooks";
import RichTextEditor from "../components/RichTextEditor";
import { showDialog } from "@jitcoder/solid-dialog";
import { useNavigate } from "@solidjs/router";

const RunBookDialog = ({ submit, ...props }) => {
  const [title, setTitle] = createSignal(props.title || '');
  const [book, setBook] = createSignal(props.book || '');

  return (
    <Dialog open={true} fullWidth={true} maxWidth={false}>
      <DialogTitle>{props.edit ? 'Edit' : 'Create'} Runbook</DialogTitle>
      <DialogContent sx={{ height: '600px' }}>
        <Grid container spacing={2} mt={1}>
          <Grid item xs={12}>
            <TextField label="Title" value={title()} onChange={(e) => setTitle(e.target.value)} fullWidth />
          </Grid>
          <Grid item xs={12}>
            <RichTextEditor height={'450px'} value={book()} onChange={setBook} />
          </Grid>
        </Grid>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button color='error' onClick={() => submit()}>Cancel</Button>
        <Button color='primary' variant="contained" onClick={() => submit({ ...props, title: title(), book: book() })}>Save</Button>
      </DialogActions>
    </Dialog>
  )
}

const RunBooks = () => {
  const [runbooks, { refetch: refetchRunbooks }] = createResource(() => getRunbooks());
  const navigate = useNavigate();

  const onCreateClick = async () => {
    const result = await showDialog(RunBookDialog);

    if (result) {
      await upsertBook(result);
      refetchRunbooks(Date.now());
    }
  }

  const onEditClick = async (id) => {
    const runbook = await getRunbook(id);
    const result = await showDialog(RunBookDialog, { ...runbook, edit: true });

    if (result) {
      await upsertBook(result);
      refetchRunbooks(Date.now());
    }
  }

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 8 }}>
      <Paper sx={{ p: 0, borderRadius: 4, position: 'relative', overflow: 'hidden', boxShadow: 3, minHeight: '400px' }}>
        <Backdrop open={Array.isArray(runbooks()) && runbooks.loading === true} sx={{ position: 'absolute', zIndex: 1, color: '#fff', bgcolor: 'rgba(255,255,255,0.5)' }}>
          <CircularProgress color="primary" />
        </Backdrop>

        <Box sx={{ p: 3, bgcolor: 'grey.50', display: "flex", flexWrap: "wrap", gap: 2, alignItems: "center", justifyContent: 'flex-end' }}>
          <Button variant="contained" onClick={onCreateClick}>Create Runbook</Button>
        </Box>

        <Show when={Array.isArray(runbooks())}>
          <Grid container spacing={2} mt={3}>
            <For each={runbooks()}>
              {(runbook) => (
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <Card>
                    <CardContent sx={{ cursor: 'pointer' }} onClick={() => navigate(`/runbooks/${runbook.id}`)}>
                      <Stack direction='row' gap={1} alignItems="center">
                        <Book color='primary' />
                        <Typography variant="caption">{runbook.title}</Typography>
                      </Stack>
                    </CardContent>
                    <Divider />
                    <CardActions>
                      <IconButton color='success' onClick={(e) => { e.stopImmediatePropagation(); onEditClick(runbook.id) }}><Edit /></IconButton>
                      <IconButton color='error' onClick={(e) => { e.stopImmediatePropagation(); deleteRunbook(runbook.id); refetchRunbooks(Date.now()) }}><Delete /></IconButton>
                    </CardActions>
                  </Card>
                </Grid>
              )}
            </For>
          </Grid>
        </Show>
      </Paper>
    </Container>
  );
}

export default RunBooks;
